// Module
var code = "<button if=\"text\" class=\"btn\" id=\"{{elementId}}\"> {{text}} </button> ";
// Exports
export default code;